import { useEffect, useState } from "react";
import {
  useClearRefinements,
  useRefinementList
} from "react-instantsearch-core";
import { Tabs } from "shared/components/Tabs";

enum TabType {
  Not_subscribed = "not_enrolled",
  Failed = "error",
  Subscribed = "enrolled",
  All = "All"
}

type Props = {
  clearSelectedRows: () => void;
};

export const RentersTabs = ({ clearSelectedRows }: Props) => {
  const [selectedTab, setSelectedTab] = useState(TabType.Not_subscribed);

  const { items, refine } = useRefinementList({
    attribute: "boomEnrollmentStatus"
  });

  const { refine: clear } = useClearRefinements({
    includedAttributes: ["boomEnrollmentStatus"]
  });

  useEffect(() => {
    const status = items.find((item) => item.isRefined)?.label;
    if (status) setSelectedTab(status as TabType);
    else setSelectedTab(TabType.All);
  }, [items]);

  return (
    <Tabs
      tabs={Object.values(TabType)}
      selected={selectedTab}
      setActiveTab={(el) => {
        // clear algolia refinements
        clear();
        // clear selected rows
        clearSelectedRows();

        if (el !== TabType.All) refine(el);
        else refine("");
      }}
      displayMap={{
        [TabType.Not_subscribed]: (
          <>
            Not subscribed
            {(items.find((item) => item.label === "not_enrolled")?.count || 0) >
              0 && (
              <div className="flex h-4 items-center rounded bg-primary-500 px-1 text-white">
                <p className="text-[10px] font-bold">
                  {items.find((item) => item.label === "not_enrolled")?.count}
                </p>
              </div>
            )}
          </>
        ),
        [TabType.Failed]: (
          <>
            Failed to subscribe
            {(items.find((item) => item.label === "error")?.count || 0) > 0 && (
              <div className="flex h-4 items-center rounded bg-danger-500 px-1 text-white">
                <p className="text-[10px] font-bold">
                  {items.find((item) => item.label === "error")?.count}
                </p>
              </div>
            )}
          </>
        ),
        [TabType.Subscribed]: "Subscribed",
        [TabType.All]: "All"
      }}
    />
  );
};
